<template>
    <div>
        <div class="seach">
            <a-radio-group :value="typeNum||type" @change="handleSizeChange">
                <a-radio-button value="1">
                    昨天
                </a-radio-button>
                <a-radio-button value="2">
                    近7天
                </a-radio-button>
                <a-radio-button value="3">
                    近30天
                </a-radio-button>
            </a-radio-group>

            <a-range-picker class="seachs" :disabled-date="disabledDate" v-model=" search_time" allowClear :showTime="false" style="margin-left: 20px" format="YYYY-MM-DD" @change="onChange"/>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name: "seach",
        data(){
            return{
                type:"3",
                search_time:[],
            }
        },
        props:{ typeNum: { default: "3" }} ,
        watch:{
            typeNum(a,b){
                this.type=a
            }
        },
        methods:{
            disabledDate(current) {
                // Can not select days before today and today
                return current && current > moment().add(-1, 'd');
            },
            handleSizeChange(e) {
                this.search_time =[]
                let type=e.target.value
                this.type = e.target.value;
                this.$emit('typeChang',type)
            },
            onChange(date, dateString) {
                this.search_time=date
                    this.type =""
                dateString[0] = moment(dateString[0]).format('YYYY-MM-DD')
                dateString[1] = moment(dateString[1]).format('YYYY-MM-DD')
                let dateStrings=`${dateString[0]}~${dateString[1]}`
                if(date.length>0)this.$emit('dateChang',dateStrings)

            },
        }
    }
</script>

<style scoped>

</style>
